export const PayrollValidationHttpErrorCodes = [422, 423, 424];
export const TimeTrackingDateFormatDashes = 'YYYY-MM-DD';
